import { render, staticRenderFns } from "./RHV.vue?vue&type=template&id=85790cd4&scoped=true"
import script from "./RHV.vue?vue&type=script&lang=js"
export * from "./RHV.vue?vue&type=script&lang=js"
import style0 from "./RHV.vue?vue&type=style&index=0&id=85790cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85790cd4",
  null
  
)

export default component.exports